import * as THREE from 'three';
import type { Input } from '../engine/Input';

export class FollowCamera {
  private yaw = 0;
  private pitch = 0.35;
  private distance = 7;
  private target = new THREE.Vector3();

  constructor(private camera: THREE.PerspectiveCamera, private input: Input) {}

  get currentYaw(): number { return this.yaw; }

  tick(dt: number, playerPos: THREE.Vector3, eyeHeight = 1.3): void {
    const md = this.input.mouseDelta();
    if (this.input.isLocked()) {
      this.yaw -= md.dx * 0.0025;
      this.pitch -= md.dy * 0.0025;
    }
    this.pitch = THREE.MathUtils.clamp(this.pitch, -0.5, 1.2);

    const wheel = this.input.wheelStep();
    if (wheel) this.distance = THREE.MathUtils.clamp(this.distance + wheel * 0.8, 3, 14);

    this.target.lerp(new THREE.Vector3(playerPos.x, playerPos.y + eyeHeight, playerPos.z), 1 - Math.pow(0.001, dt));

    const x = Math.sin(this.yaw) * Math.cos(this.pitch) * this.distance;
    const z = Math.cos(this.yaw) * Math.cos(this.pitch) * this.distance;
    const y = Math.sin(this.pitch) * this.distance;

    this.camera.position.set(this.target.x + x, this.target.y + y, this.target.z + z);
    this.camera.lookAt(this.target);
  }
}
